<template>
    <header class="header" v-if="setup != null" id="header">
        <div class="container">
            <div class="header-container">
                <navMain class="header-navigation newyear-2021"></navMain>
                <div class="right-header">
                    <div class="mobile-menu" :class="{open: openSendwich}" @click="openMobileMenu(!openSendwich)" v-if="iSmobile">
                        <span></span>
                    </div>
                    <div class="lang">
                        <div class="lang--picker">
                            <a href="#" class="lang-link-select">
                                <span class="body-lang-ru">Рус</span>
                                <span class="body-lang-kz">Каз</span>
                            </a>
                        </div>
                        <div class="select--languages dropdown-menu">
                            <ul>
                                <li class="select-link select-link-ru">
                                    <a href="#" @click.prevent="setLocale('')">Рус</a>
                                </li>
                                <li class="select-link select-link-kz">
                                    <a href="#" @click.prevent="setLocale('kz/')">Каз</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="city-select">
                        <div class="city-picker" v-if="currentCityArr != null">
                            <a href="#" class="city-link-picker" @click.prevent="dropdownCity = !dropdownCity">
                                <span>{{currentCityArr[0].region}}</span>
                            </a>
                        </div>
                        <div class="city-picker-select dropdown-menu" :class="{open : dropdownCity}">
                            <ul>
                                <li v-for="(item, index) in setup.regions_name" v-if="item.city_init == 'true'">
                                    <a href="#" @click.prevent="setCurrentCity(item.region_lat.slug)">{{item.region}}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="phone-current-city" v-if="currentCityArr != null">
                        <a :href="'tel:' + currentCityArr[0].region_phone" class="phone-number">{{currentCityArr[0].region_phone}}</a>
                    </div>
                    <div class="user-links">
                        <div class="item">
                            <a :href="URLrocketLC + '/?lang=' + langVAR" @click.prevent="linkToCabinet" target="_blank" class="cabinet-link">
                                <svg-icon icon-class="login" className="icon-user"/>
                                <span>Личный кабинет</span>
                            </a>
                        </div>
                        <div class="item item-icon">
                            <router-link :to="{ name : 'favorite-page' }" :class="{'active' : countFavorite > 0}" @click.native="startLoader">
                                <svg-icon icon-class="star" className="icon-star"/>
                                <!-- <div class="count" v-if="countFavorite > 0"><span>{{countFavorite}}</span></div> -->
                            </router-link>
                        </div>
                    </div>
                    <div class="logo-bazis">
                        <router-link to="/" @click.native="startLoader">
                            <img src="https://sales.bazis.kz/cms/media/2020/12/logo_bazis_new_newyear2021_01.svg" alt="sales.bazis.kz BAZIS-A">
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
    import {mapGetters} from 'vuex'
    import navMain from '@/components/nav-main/nav-main.vue'
    export default {
        name: 'AppHeader',
        components: {
            navMain,
        },
        data () {
            return {
                regionCity: null,
                regionCityArr: null, 
                dropdownCity: false,
                iSmobile: false,
                langVAR: window.LangVar,
            }
        },
        computed: mapGetters({
            setup: 'loadPageSetUp',
            currentCity: 'loadCurrentCity',
            currentCityArr: 'loadCurrentCityArr',
            countFavorite: 'loadFavoriteCount',
            openSendwich: 'loadOpenSendwich',
            URLrocketLC: 'loadUrlRocketLC',
        }),
        methods: {
            setLocale(lang) {
                localStorage.setItem('language', lang);
                document.location.reload(true);
            },
            setCurrentCity(city) {
                this.dropdownCity = !this.dropdownCity;
                this.$store.commit('CurrentCity', city);
                localStorage.setItem('regionCity', city);
                this.filterRegion(city);
                this.regionCity = city;
                document.location.reload(true);
            },
            changeLang () {
                var dataLang = window.body.data('language'),
                    btnKz = $('.body-lang-kz'),
                    btnRu = $('.body-lang-ru'),
                    selectRu = $('.select-link-ru'),
                    selectKz = $('.select-link-kz'),
                    link = $('.lang-link-select'),
                    switchContainer = $('.select--languages');
                if (dataLang == '') {
                    btnRu.addClass('active');
                    selectRu.addClass('active');
                } else {
                    btnKz.addClass('active');
                    selectKz.addClass('active');
                }
                link.on('click', function(e){
                    e.preventDefault();
                    e.stopPropagation();
                    $(this).stop(true).toggleClass('open');
                    $(this).closest('.lang').find('.select--languages').stop(true).toggleClass('open');
                });
                $(document).on('click', function closeMenu (e){
                    if(link.has(e.target).length === 0){
                        switchContainer.removeClass('open');
                        link.removeClass('open');
                    } else {
                        $(document).one('click', closeMenu);
                    }
                });
            },
            setCockieStorage() {
                if (window.GlobalRegion == null) {
                    axios.get('https://api.ipgeolocation.io/ipgeo?apiKey=66140a3e1b064ac4b8b94582d9e15bec')
                    // 66140a3e1b064ac4b8b94582d9e15bec
                    .then(response => {
                        // console.log(response, 'LOCATION')
                        var city = response.data.city.toLowerCase();
                        // console.log(city);
                        var cityArr = this.setup.regions_name;
                        var filteredCity = cityArr.filter(item => {
                            return item.region_lat.slug == city && item.city_init == 'true';

                        });
                        if (filteredCity.length != 0) {
                            this.$store.commit('CurrentCity', city);
                            localStorage.setItem('regionCity', city);
                            this.regionCity = city;
                            this.filterRegion(city);
                        } else {
                            this.$store.commit('CurrentCity', 'almaty');
                            localStorage.setItem('regionCity', 'almaty');
                            this.filterRegion('almaty');
                            // this.regionCityArr = this.setup.regions_name[0];
                        }
                    }).catch(error => {
                        console.log('error', error);
                        this.$store.commit('CurrentCity', 'almaty');
                        localStorage.setItem('regionCity', 'almaty');
                        this.filterRegion('almaty');
                        this.regionCity = 'almaty';
                    })
                } else {
                    this.filterRegion(window.GlobalRegion);
                    // this.regionCityArr = window.GlobalRegion;
                }
            },
            filterRegion(city) {
                var data = this.setup.regions_name;
                var filteredItems = data.filter(item => {
                    return item.region_lat.slug === city
                })
                // console.log(filteredItems)
                this.$store.commit('CurrentCityArr', filteredItems);
                // this.regionCityArr = filteredItems;
            },
            openMobileMenu(data) {
                this.$store.commit('Open_Sendwich', data);
                this.$store.commit('Open_form_Consult', false);
                document.getElementsByTagName('body')[0].classList.toggle('overlay-open');
            },
            startLoader() {
                this.$parent.$refs.topProgress.start();
            },
            linkToCabinet() {
                // console.log(this.window.rockeLC, 'asdsadasda')
                var exist = localStorage.getItem('favorite_flats');
                exist = exist ? exist.split(',') : [];
                var url = this.URLrocketLC + '/?lang=' + this.langVAR;
                var favoriteUrl;
                if (exist.length > 0) {
                    favoriteUrl = '&favoritesFlats=' + exist.join(',');
                    console.log(exist, favoriteUrl);
                    window.open(
                        url + favoriteUrl,
                        '_blank'
                    );
                } else {
                    window.open(
                        url,
                        '_blank'
                    );
                }
            },
            // MOBILE CHECKER
            isMobileCheck() {
                if (window.innerWidth < 767) {
                    this.iSmobile = true
                }
            },
            handleResize() {
                if (window.innerWidth < 767) {
                    this.iSmobile = true
                } else {
                    this.iSmobile = false
                }
            },
            checkResize() {
                window.addEventListener('resize', this.handleResize)
                this.handleResize();
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            this.isMobileCheck();
            this.checkResize();
            this.$store.watch(
                (state) => state.pageSetup,
                (newValue) => {
                    if (newValue != null) {
                        this.changeLang();
                        this.setCockieStorage();
                    }
                }
            )
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/header/header.scss';
    @import '@/styles/respond/header/respond-header.scss';
</style>